<template>
  <h4 class="text-center" :class="{'text-[var(--color-disabled)]': editable === false}"
   id="txt_time">{{ updateText }}</h4>
  <div class="flex flex-row items-center justify-center my-6 mx-0">
    <vee-field v-model="time"
               :readonly="editable === false"
               type="time"
               class="text-3xl font-bold"
               :class="{'text-[var(--color-disabled)]': editable === false}"
               name="start-time"
               id="input_cal-time"/>
  </div>
  <edit-kss-recurring-task-component v-if="!hideRecurring"
                                     :initialRecurring="initialRecurring"
                                     :initialIncludeWeekends="initialIncludeWeekends"
                                     :anchorDate="initialDate"
                                     :editable="editable"
                                     @updateReccuring="updateReccuring"/>
</template>

<script>
import EditKssRecurringTaskComponent
  from '@/components/Home/KssCreator/KssEditComponents/EditKssRecurringTaskComponent.vue';

export default {
  props: {
    editable: {
      type: Boolean,
    },
    initialDate: {
      type: Date,
      default: null,
    },
    initialRecurring: {
      type: Object,
      default: null,
    },
    initialIncludeWeekends: {
      type: Boolean,
      default: null,
    },
    isStartTime: {
      type: Boolean,
    },
    hideRecurring: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['updateTime', 'updateReccuring'],
  name: 'EditKssRuntimeComponent',
  components: { EditKssRecurringTaskComponent },
  data() {
    return {
      time: null,
    };
  },
  computed: {
    updateText() {
      if (this.isStartTime === 'true') {
        return this.$t('KssRuntimeComponent.headingStartRuntime');
      }
      return this.$t('KssRuntimeComponent.headingRuntime');
    },
  },
  watch: {
    initialDate: {
      deep: true,
      handler() {
        this.applyInitialTime();
      },
    },
    time(newTime) {
      this.$emit('updateTime', newTime);
    },
  },
  methods: {
    updateReccuring(value) {
      this.$emit('updateReccuring', value);
    },
    applyInitialTime() {
      if (this.initialDate && typeof this.initialDate.getHours === 'function') {
        this.time = `${(`0${this.initialDate.getHours()}`).slice(-2)}:${(`0${this.initialDate.getMinutes()}`).slice(-2)}`;
      } else {
        this.time = `${(`0${new Date().getHours()}`).slice(-2)}:${(`0${new Date().getMinutes()}`).slice(-2)}`;
      }
    },
  },
  mounted() {
    this.applyInitialTime();
  },
};
</script>
